module.exports = function (fox) {
	'use strict';

	var $ = fox.jQuery;

	fox.registerWidget('ValentinesGiftsPopup', {
		configure: function () {
			this.registerOptions('', {
				autoRender: false,
				manualRende: true,
				'embed.container': '#valentines-gifts-popup',
				template: 'layout_gifts_popup',
				widgets: {
					giftBoxBody: {
						widget: 'Giftbox',
						autoRender: true,
						giftType: 'default',
						giftPaymentSuccess: 'inboxSocketEventConversation:giftUnlock',
						'embed.container': '.gift-list-container',
						template: 'layout_gifts_container',
						targetIdCb: function () {
							return fox.getEnv('site.conversationId');
						},
						userRegistration: function () {
							var giftBox = this.wom1('#giftBoxBody');
							var purchaseGuest = giftBox.wom1('#purchaseGuest');
							var guestForm = purchaseGuest.wom1('#regForm');

							purchaseGuest.render();
							$(purchaseGuest.getOption('embed.container')).show();

							var elt = fox.dom.selectFirst('.gift-list-container');
							fox.dom.addClass('blur', elt);

							return new fox.Promise(function (resolve) {
								this.__resolver = resolve;
							}.bind(this)).then(function (result) {
								this.__resolver = null;
								return result;
							}.bind(this)).catch(function (error) {
								this.__resolver = null;
								throw error;
							}.bind(this));
						}.bind(this),

						showUnchecked: function() {
							var button = document.querySelector('#send-gift');
							var giftBoxBody = fox.site.wom1('~.ValentinesGiftsPopup #giftBoxBody');
							var toggleButton = function () {
								button.disabled = !button.disabled;
							};
							toggleButton();
							setTimeout(toggleButton, 450)

							document.querySelectorAll('[data-gid]').forEach(function (el, i) {
								var togglePrice = function() {
									giftBoxBody = fox.site.wom1('~.ValentinesGiftsPopup #giftBoxBody');
									giftBoxBody.checkGiftMultiple(el);
								}
								togglePrice();
								setTimeout(togglePrice, 400)
							}.bind(this))
						},

						widgets: {
							giftboxList: {
								'tpl.row': 'gifts__list_row',
							},
							purchaseGuest: {
								widget: 'Widget',
								template: 'gift_purchase_guest',
								'embed.container': '.giftbox-guest-form',
								autoRender: false,
								widgets: {
									regForm: {
										widget: 'DomForm',
										formSelector: '#gift-reg-form'
									}
								},
								'handleWom.formInvalidate': {
									event: ['form_not_valid', 'form_valid'],
									widget: '#regForm',
									callback: function (info) {
										info.forEach(function (inf) {
											if (inf.result === false) {
												this.showError(inf.field);
											} else {
												this.hideError(inf.field);
											}
										}.bind(this))

									}.bind(this)
								},
								'handleDom.submit': {
									event: 'click',
									target: '#gift-login',
									callback: this.onSubmit.bind(this)
								},

								'handleDom.focus': {
									target: 'input',
									event: 'focus',
									callback: function (el, alias, scope, event) {
										event.preventDefault();
										event.stopPropagation();
										var errorEl = el.closest('.error');
										fox.dom.removeClass('error', errorEl);
									}
								}
							}
						},
						'hooks.onPrepareParams': function (params) {
							var elt = this.wom1('#giftBoxBody').dom1('[name="gift_message"]');
							var msg = elt.value;
							var blurred = $('#valentines-gifts-popup .blurred');
							blurred.show();
							if (msg) {
								params.message = msg;
							} else {
								params.message = elt.getAttributeNode('placeholder').value
							}
						}.bind(this)
					}
				},
				handleDom: {
					toggle: {
						targetWidget: '#giftBoxBody',
						target: '.popup-title-wrapper',
						callback: 'toggle'
					}
				},

				handleWom: {
					giftsAvailable: {
						widget: '#giftBoxBody',
						event: 'giftsAvailable',
						callback: 'render'
					},
					giftSended: {
						event: 'giftPaid',
						widget: '#giftBoxBody',
						callback: 'giftPaid'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.isOpened = false;
			this.ga = fox.wom.selectFirst('@root #googleAnalytics');
			this.callParent('init', arguments);
		},
		toggle: function () {
			this[(this.isOpened ? 'hide' : 'show')]();
		},

		hide: function () {
			var elm = this.dom1('.valentines-gift-popup');
			this.isOpened = false;
			fox.dom.removeClass('opened', elm);
			fox.dom.removeClass('open', elm.parentNode);
			
			$('#valentines-gifts-popup .blurred').hide();
		},

		show: function () {
			var wrapper = $('#valentines-gifts-popup .giftbox-wrapper');
			var asix = (window.innerWidth < 768) ? 'x' : 'y';
			wrapper.mCustomScrollbar('destroy');
			wrapper.mCustomScrollbar({
				axis: asix
			});
			
			this.guestFormRemove();

			var giftBoxBody = this.wom1('#giftBoxBody');
			var elm = this.dom1('.valentines-gift-popup');

			var checkedGift = giftBoxBody.checkedGifts;
			if (!fox.isEmpty(checkedGift)) {
				var checkedElt = document.querySelector('[data-gid="' + checkedGift[0]+'"]');
				giftBoxBody.checkGiftSingle(checkedElt);
			}

			this.isOpened = true;
			var eventCategory = this.isGuest() ? 'RevenueGuest' : 'RevenueMember';
			this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: eventCategory, eventAction: 'OpenWidget' });
			
			fox.dom.addClass('opened', elm);
			fox.dom.addClass('open', elm.parentNode);
		},

		giftPaid: function () {
			var eventCategory = this.isGuest() ? 'RevenueGuest' : 'RevenueMember';
			this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: eventCategory, eventAction: 'SuccessfulPurchase' });
			var congrats = $('#valentines-gifts-popup .congrats');
			var blurred = $('#valentines-gifts-popup .blurred');
			congrats.addClass('show');
			var t = setTimeout(this.render.bind(this), 5000);
		},

		isGuest: function(){
			var pm = fox.site.wom1('.PermissionManager');
			return (pm.hasAccess('guest') && fox.isEmpty(pm.getMemberInfo())) ? true : false;
		},

		onSubmit: function (button, alias, scope, event) {
			var purchaseGuest = this.wom1('#giftBoxBody #purchaseGuest');
			var guestForm = purchaseGuest.wom1('#regForm');
			event.preventDefault();
			event.stopPropagation();
			$(button).toggleClass('spin')
			guestForm.submit().then(function (values) {
				if (values !== false) {
					this.guestFormRemove();
					if (this.__resolver)
						this.ga.trackEvent({ eventLabel: 'GiftsWidget', eventCategory: 'RevenueGuest', eventAction: 'SecondSendClick' });	
						this.__resolver(this.wom1('#giftBoxBody').autoLoginService.injectToken(values, fox.values(values).join(':')));
				} else {
					$(button).toggleClass('spin')
				}
			}.bind(this));
		},

		guestFormRemove: function() {
			var purchaseGuest = this.wom1('#giftBoxBody #purchaseGuest');
			purchaseGuest.removeFromDom();
			var elt = fox.dom.selectFirst('.gift-list-container');
			fox.dom.removeClass('blur', elt);
		},

		showError: function (name, msg) {
			var el = this.dom1('[name="' + name + '"]');
			var field = el.closest('.row');

			if (!field) {
				return;
			};

			fox.dom.addClass('error', field);
			fox.dom.removeClass('success', field);
			fox.dom.selectFirst('.error-message', field).innerHTML = (el.validationMessage || '&nbsp;');
		},

		hideError: function (name) {
			var field = this.dom1('[name="' + name + '"]');
			if (!field || !field.closest('.error')) 
				return false;
			var errorField = field.closest('.error');
			
			fox.dom.removeClass('error', errorField);
			fox.dom.selectFirst('.error-message', errorField).innerHTML = ('&nbsp;');
		}
	});
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/valentinesPopup.js
// module id = 733
// module chunks = 4